import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoTipoDocumentacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoTipoDocumentacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getProyectoTipoDocumentacionService(): Observable<BodyListResponse<ProyectoTipoDocumentacionDTO>> {
    return this.http.get<BodyListResponse<ProyectoTipoDocumentacionDTO>>(API_URL + '/api/v1/proyectoTipoDocumentacion/todos');
  }

  guardarProyectoTipoDocumentacionService(proyectoTipoDocumentacionDTO: ProyectoTipoDocumentacionDTO): Observable<BodyResponse<ProyectoTipoDocumentacionDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/proyectoTipoDocumentacion', proyectoTipoDocumentacionDTO);
  }

  getProyectoTipoDocumentacionPorCodigoService(codigo: string): Observable<BodyResponse<ProyectoTipoDocumentacionDTO>> {
    return this.http.get<BodyResponse<ProyectoTipoDocumentacionDTO>>(API_URL + '/api/v1/proyectoTipoDocumentacion/' + codigo);
  }
  /************ */


  getProyectoTipoDocumentacionTipoProcesoService(codigo: string): Observable<BodyListResponse<ProyectoTipoDocumentacionDTO>> {
    return this.http.get<BodyListResponse<ProyectoTipoDocumentacionDTO>>(API_URL + '/api/v1/proyectoTipoDocumentacion/tipoProceso/'+codigo);
  }
}
